const translations = {
    'actions.build': 'Build',
    'actions.buildBlacksmith': 'Build blacksmith (%s)',
    'actions.buildCaravanPost': 'Build caravan post (%s)',
    'actions.buildCharcoalPit': 'Build charcoal pit (%s)',
    'actions.buildFarm': 'Build farm (%s)',
    'actions.buildFishingHut': 'Build fishing hut (%s)',
    'actions.buildGoldMine': 'Build gold mine (%s)',
    'actions.buildHouse': 'Build house (%s)',
    'actions.buildHuntingHut': 'Build hunting hut (%s)',
    'actions.buildIronMine': 'Build iron mine (%s)',
    'actions.buildLumberjack': 'Build lumberjack camp (%s)',
    'actions.buildMasonry': 'Build masonry (%s)',
    'actions.buildMint': 'Build mint (%s)',
    'actions.buildQuarry': 'Build quarry (%s)',
    'actions.buildSawmill': 'Build sawmill (%s)',
    'actions.buildSmelter': 'Build smelter (%s)',
    'actions.buildSmokehouse': 'Build smokehouse (%s)',
    'actions.buildStable': 'Build stable (%s)',
    'actions.buildWeaver': 'Build weaver (%s)',
    'actions.foundSettlement': 'Found settlement (%d pop)',
    'actions.cancel': 'Cancel',
};

export default translations;
